import { ref } from 'vue';
import { useAsyncState } from '@vueuse/core';
import bugsnagClient from '@getaccept/lib-shared/src/bugsnag';
import * as VerifyUserHelper from '../helpers/verify-user.helper';
import type { ProfileInformation } from '../types/profile-information';
import { VerifyUserServiceV3, VerifyUserService } from '../services/verify-user.service';
import { useGoogleTagManager } from '../../common/composables/google-tag-manager.composable';

export const useVerifyUser = () => {
  const error = ref();

  const verifyUser = async (
    profileInformation: ProfileInformation,
    id: string,
    key: string,
    isInvitation: boolean = false,
    version: number = 2
  ) => {
    try {
      VerifyUserHelper.trackUserInfo(profileInformation, id);
      let url: string;

      if (version === 3) {
        url = await VerifyUserServiceV3.verify({ profileInformation, id, key, isInvitation });
      } else {
        url = await VerifyUserService.verify({ profileInformation, id, key });
      }

      useGoogleTagManager().addUserInfo(id, profileInformation);
      return url;
    } catch (e) {
      error.value = VerifyUserHelper.getErrorMessage(e);
      VerifyUserHelper.trackVerifyUserError(error.value);
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
    }
  };

  const query = useAsyncState(verifyUser, null, { immediate: false });

  return { ...query, error };
};
